import React from 'react';
import styled from 'styled-components';
import { IndicatorSectionKey } from '../ImpactIndicator/utils';
import { IndicatorDetails } from './utils';
import IndicatorSectionContent from './IndicatorSectionContent';
import IndicatorSectionUnselected from './IndicatorSectionUnselected';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

export const INDICATOR_CURVE_SVG = (
  <svg
    className="right"
    width="146"
    height="267"
    viewBox="0 0 146 267"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={'M12 0.5H59.3965C63.396 0.5 67.1082 2.57792 69.1994 5.98713L143.725 127.487C145.988 131.176 145.988 135.824 143.725 ' +
        '139.513L69.1993 261.013C67.1082 264.422 63.396 266.5 59.3965 266.5H12C5.64873 266.5 0.5 261.351 0.5 255V12C0.5 5.64872 ' +
        '5.64873 0.5 12 0.5Z'}
      fill="white"
      stroke="#FF8300"
    />
  </svg>
);

interface IndicatorSectionSelectedProps {
  sectionKey: IndicatorSectionKey;
  sectionName: string;
  indicator: IndicatorDetails;
  totalIndicators: number;
  index: number;
  zIndex?: number;
  selected: boolean;
  isLastIndex: boolean;
  className?: string;
}

const StyledDiv = styled.div<{ zIndex?: number; isLastIndex: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  ${({ zIndex }) => (zIndex ? `z-index: ${zIndex};` : '')}
  .left {
    height: 267px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    width: calc(100% - 146px);
    background: #fff;
    border-top: 1px solid ${COLORS.ctaBrand};
    border-bottom: 1px solid ${COLORS.ctaBrand};
    border-left: 1px solid ${COLORS.ctaBrand};
    border-radius: 12px 0 0 12px;
    ${({ isLastIndex }) =>
      isLastIndex
        ? `border-right: 1px solid ${COLORS.ctaBrand}; border-radius: 12px; padding-right: ${SPACERS.large}`
        : ''}
  }
  .right {
    z-index: -1;
    position: absolute;
    right: 60px;
  }
`;

const IndicatorSectionSelected: React.FC<IndicatorSectionSelectedProps> = ({
  sectionKey,
  sectionName,
  indicator,
  totalIndicators,
  index,
  zIndex,
  selected,
  isLastIndex,
  className,
}) => {
  return (
    <StyledDiv zIndex={zIndex} isLastIndex={isLastIndex}>
      <div className={`left ${className}`}>
        {selected ? (
          <IndicatorSectionContent
            sectionKey={sectionKey}
            sectionName={sectionName}
            indicator={indicator}
            totalIndicators={totalIndicators}
            index={index}
          />
        ) : (
          <IndicatorSectionUnselected
            totalIndicators={totalIndicators}
            sectionKey={sectionKey}
            sectionName={sectionName}
          />
        )}
      </div>
      {!isLastIndex && INDICATOR_CURVE_SVG}
    </StyledDiv>
  );
};

export default IndicatorSectionSelected;
